import { IAppState } from '@/interfaces/app-state.interface';
import { ActionContext } from 'vuex';
import { IAppConfirm } from '@/modules/Popup/interfaces/app-confirm-state.interface';
import _ from 'lodash';
import {isMobile} from "mobile-device-detect";
import router from "@/router";

type ConfirmActionContext = ActionContext<IAppConfirm.State, IAppState>;

export const ConfirmPopupStore: ConfirmActionContext = {
  // @ts-ignore
  namespaced: true,

  state: {
    title: '',
    text: '',
    class: '',
    cancel: {
      text: '',
      rootAction: null,
      payload: null
    },
    confirm: {
      text: '',
      rootAction: null,
      payload: null,
      action: null,
    },
    isVisible: false
  },

  mutations: {
    open(state: any, data: IAppConfirm.ActionDataOpen) {
      data = _.defaultsDeep(data, {
        title: 'Подтверждение',
        class: 'default',
        cancel: {
          text: 'Отменить',
          rootAction: null,
          payload: null
        },
        confirm: {
          text: 'Подтвердить',
          rootAction: null,
          payload: null,
          action: null,
        }
      });

      state.title = data.title;
      state.text = data.text;
      state.cancel = data.cancel;
      state.confirm = data.confirm;
      state.isVisible = true;
      state.class = data.class;
    },

    close(state: any) {
      state.title = '';
      state.text = '';
      state.cancelText = '';
      state.confirmText = '';
      state.isVisible = false;
    }
  },

  actions: {
    open({ commit, rootState }: ConfirmActionContext, data: IAppConfirm.ActionDataOpen) {
      commit('open', data);

      if (isMobile) {
        router.push({name: rootState.route.name, query: {...rootState.route.query, dialog: 'confirm',}});
      }
    },

    confirm({ state, commit, dispatch }: ConfirmActionContext) {
      if (state.confirm.action) {
        state.confirm.action();
      }
      else {
        if (state.confirm.rootAction) {
          dispatch(state.confirm.rootAction, state.confirm.payload, {root: true});
        }
      }
      dispatch('close');
    },

    cancel({ state, commit, dispatch }: ConfirmActionContext) {
      if (state.cancel.action) {
        state.cancel.action();
      }
      else if (state.cancel.rootAction) {
        dispatch(state.cancel.rootAction, state.cancel.payload, { root: true });
      }

      dispatch('close');
    },

    close({ rootState, commit, }: ConfirmActionContext) {
      commit('close');

      if (isMobile) {
        const query = _.clone(rootState.route.query);
        if (query.dialog) {
          router.go(-1);
        }
      }
    }
  }
};
